import TablePagination from './TablePagination.component';

export default TablePagination;
